
import { Form } from 'vee-validate';
import { defineComponent, Ref, ref } from 'vue';
import AppButton from '@/components/UI/AppButton.vue';
import { REGISTRATION_GROUP } from '@/types/enums';
import { IGroupEmit } from '@/types/interfaces';

export default defineComponent({
  name: 'GroupsAddSettings',
  components: {
    Form,
    AppButton,
  },
  setup(props, context) {
    const inputData:Ref<string> = ref('');
    function nextStep() {
      context.emit('setGroupData', { value: inputData.value, type: REGISTRATION_GROUP.ADD_SETTINGS } as IGroupEmit);
    }
    return {
      inputData,
      nextStep,
    };
  },
});
